import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MuiThemeProvider, createTheme } from '@material-ui/core';
import { resultsConfigSelector } from 'ctm-selectors';
import Dialog from '@material-ui/core/Dialog';
import { withRules, SimpleFlexbox, Text, ModalCloseIcon } from 'ctm-components';
import { useBrandContentFactory } from 'ctm-app/client/hooks/useBrandContentFactory';

const theme = createTheme({
    overrides: {
        MuiPaper: {
            root: {
                padding: '2rem',
                // To fix the absolute-positioned close icon being cut off
                overflowY: 'unset !important'
            }
        }
    }
});

/**
 * This is the Redbook Disclosure Modal.
 * @param {Object} props React props.
 * @returns {RedbookDisclosureModal} The RedbookDisclosure modal
 */
const _RedbookDisclosureModal =  (props) => {
    const { redbookDisclosureModalIsOpen, closeModal } = props;

    const brandContentFactory = useBrandContentFactory();
    const redbookDisclosureContent = brandContentFactory.redbookDisclosureContent();

    /**
     * Render top-right modal close icon button
     * @return {Node} the CloseIcon button
     */
    const renderCloseIcon = () => {
        const closeIconProps = { onClickFunction: closeModal };
        return React.createElement(ModalCloseIcon, closeIconProps);
    };

    return (
        <MuiThemeProvider theme={theme}>
            <Dialog fullWidth open={redbookDisclosureModalIsOpen} onClose={closeModal} disableBackdropClick disableEscapeKeyDown>
                <SimpleFlexbox display="flex" column>
                    {/* Render title only if it's not empty */}
                    {redbookDisclosureContent.title && (
                        <Text tagName="h3" color="brand_primary" dataId="redbookDisclosureHeading">{redbookDisclosureContent.title}</Text>
                    )}

                    {/* Render description only if it's not empty */}
                    {redbookDisclosureContent.description && (
                        <Text tagName="p">{redbookDisclosureContent.description}</Text>
                    )}
                </SimpleFlexbox>
                {renderCloseIcon()}
            </Dialog>
        </MuiThemeProvider>
    );
};

_RedbookDisclosureModal.propTypes = {
    redbookDisclosureModalIsOpen: PropTypes.bool,
    closeModal: PropTypes.func
};

/**
 * mapStateToProps - sets up the rules required by this component
 * @param {Object} state - Redux store state.
 * @return {Object} - The state attributes to add to props.
 */
const mapStateToProps = (state) => {
    const redbookDisclosureModal = resultsConfigSelector(state).getIn(['helpers', 'redbookDisclosure']);

    return {
        redbookDisclosureModalIsOpen: redbookDisclosureModal ? redbookDisclosureModal.open : false
    };
};

const RedbookDisclosureModal = connect(mapStateToProps)(_RedbookDisclosureModal);

export { _RedbookDisclosureModal, RedbookDisclosureModal };
